export const fetchMalwareById = {
  pathname: id => `/api/v4/malware/${id}`,
}

export const fetchMalwareReports = {
  pathname: id => `/api/v4/malware/${id}/reports`,
}

export const fetchMalware = {
  pathname: '/api/v4/malware',
  search: ({ search }) => search,
}

export const fetchMalwareIndicators = {
  pathname: id => `/api/v4/malware/${id}/indicators`,
}

export const fetchMostActiveMalware = {
  pathname: () => '/api/v4/malware/most-active',
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: (body) => body
}
